<main class="terms-page">
  <a class="back-link" routerLink="/menu">
    <i class="fa-solid fa-arrow-left" aria-hidden="true"></i>
    <span>Back to menu</span>
  </a>

  <header class="terms-header">
    <h1>{{ terms?.title || "Terms of Service" }}</h1>
    @if (terms) {
      <div class="terms-meta">
        <span>Version {{ terms.versions }}</span>
        @if (terms.updatedAt) {
          <span>Updated {{ terms.updatedAt }}</span>
        }
      </div>
    }
  </header>

  @if (loading) {
    <section class="status-panel" aria-live="polite">
      Loading terms of service...
    </section>
  }

  @if (!loading && error) {
    <section class="status-panel status-panel--error">
      <p>{{ error }}</p>
      <button type="button" class="btn-outline" (click)="loadTerms()">
        Retry
      </button>
    </section>
  }

  @if (!loading && terms) {
    <article class="terms-content">
      <pre>{{ terms.content }}</pre>
    </article>
  }
</main>
